import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@ubisend/pulse-components';

import General from './General';
import Bubble from './Bubble';

const Carousel = ({ content, handleButtonClick, handleButtonLocationClick, direction, hasHadReply }) => (
  <Flex fat="true" xScroll xSpace>
    {content.items.map((item, key) => (
      <General
        dataTestid={`carousel-image-${key}`}
        key={key}
        type="carousel"
        direction={direction}
        content={item}
        handleButtonLocationClick={handleButtonLocationClick}
        handleButtonClick={handleButtonClick}
        hasHadReply={hasHadReply}
      />
    ))}
  </Flex>
);

Carousel.propTypes = {
  content: PropTypes.shape({
    items: PropTypes.array.isRequired
  }).isRequired,
  direction: Bubble.propTypes.direction,
  handleButtonClick: PropTypes.func.isRequired,
  handleButtonLocationClick: PropTypes.func.isRequired,
  hasHadReply: PropTypes.bool
};

export default Carousel;
